import { Box, IconButton, styled } from "@mui/material";

export const ShareLocationContainer = styled(Box)`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
`;

export const InputWrapper = styled(Box)`
  margin: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const LoadingOverlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2;
`;
